module.exports = __webpack_public_path__ + "img/jianpan.ad0f153c.png";